import { fromTheme as kyruusFromTheme } from '@kyruus/ui-theme';
import { Theme } from '@biome-design-system/styles';

import { buildButton } from './button';
import { getOverrides, type ThemeContext } from '../utils';
import { buildIconButton } from './iconButton';

/**
 * Builds the components configuration for the MUI theme based on Kyruus theme values.
 * @param {object} kyruusTheme - The Kyruus theme object
 * @param {object} biomeTheme - The Biome theme object (which is a MUI theme)
 * @returns {object} The components configuration for MUI theme
 */
export const buildComponents = (
  kyruusTheme: Record<string, unknown>,
  biomeTheme: Theme
) => {
  // wrap fromTheme to simplify the code below
  const fromTheme = (themeKey: string) =>
    kyruusFromTheme(themeKey)({ theme: kyruusTheme });

  const colorLink = fromTheme('color_link');
  const fontFace = fromTheme('font_face');

  const { root } = biomeTheme.components?.MuiLink?.styleOverrides || {};
  return {
    MuiButton: buildButton(kyruusTheme, biomeTheme),
    MuiIconButton: buildIconButton(kyruusTheme, biomeTheme),
    MuiLink: {
      root: {
        color: colorLink
      },
      styleOverrides: {
        root: ({ theme, ownerState }: ThemeContext) => ({
          ...getOverrides(root, { theme, ownerState }),
          // Visited links styling - excludes breadcrumb links
          '&:visited:not(.MuiBreadcrumbs-root .MuiLink-root)': {
            color: colorLink
          }
        })
      }
    },
    MuiTypography: {
      defaultProps: {
        variant: 'body1'
      },
      styleOverrides: {
        root: {
          fontFamily: fontFace
        }
      }
    }
  };
};
